export default __webpack_public_path__ + "static/media/it_0.87bdcc88.mp3";